import interceptor from '@/plugins/interceptor';
const pathController = '/Resources'

export default {
    state: () => ({}),
    mutations: {},
    actions: {
        async resources(_,props){
            const { page, topics, categories, search, rowsPerPage } =  props
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_URL}${pathController}?${topics !== undefined ? `topicId=${topics}&` : ''}${categories !== undefined ? `categoryId=${categories}&` : ''}${search !== undefined ? `searchText=${search}&` : ''}pageNumber=${page !== undefined ? page : ''}&rowsPerPage=${rowsPerPage}`)
        },
        async resource_byId(_,id){
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_URL}${pathController}/${id}`)
        },
        async resources_lastOrRecommended(_,quantity){
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_URL}${pathController}/lastOrRecommended?quantity=${quantity}`)
        },
        async resources_options(){
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_URL}${pathController}/options`)
        }
    }
}
